import { Anchor, Button, NavLink, type AnchorProps, type ButtonProps, type NavLinkProps } from '@mantine/core'
import { createLink } from '@tanstack/react-router'
import type { AnchorHTMLAttributes, Ref } from 'react'

/**
 * Mantine's Anchor, Button and NavLink as router links. Mantine's `component={Link}` loses the router's types for
 * `params` and `search`; createLink keeps them, so a link to `/settings/$group` is checked like any other.
 */
type AnchorAttributes = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'color' | 'style'> & { ref?: Ref<HTMLAnchorElement> }

export const AnchorLink = createLink((props: AnchorProps & AnchorAttributes) => <Anchor component="a" {...props} />)

export const ButtonLink = createLink((props: ButtonProps & AnchorAttributes) => <Button component="a" {...props} />)

export const NavLinkLink = createLink((props: NavLinkProps & Omit<AnchorAttributes, 'onChange'>) => <NavLink component="a" {...props} />)
